module.exports = __webpack_public_path__ + "825479cdee0a4f52895a7eee56569588.svg";